import { InstrumentTypeResponse } from "../codegen-api";
import { findTradingTypeByInstrument } from "../config/features";
import { AssetResponse } from "./asset";
import { getAssetShortName } from "./asset/assets";

/**
 * The market's display label — "BTC-USDC" for spot, "BTC-USD" for a perp —
 * read from the vertical's `quoteLabelSuffix` in the trading-type registry.
 *
 * Every surface that names a market must use this rather than appending a
 * hard-coded "-USD" / "-PERP": those strings are what made a spot-only build
 * call BTC-USDC "BTC-USD" in the tab title, the mobile trade sheet and the
 * watchlist. An instrument type the registry does not know, or a vertical with
 * no suffix (options), yields the bare asset name.
 */
export const instrumentLabel = (
  asset: AssetResponse | string | undefined,
  instrumentType: InstrumentTypeResponse | string | undefined
): string => {
  if (!asset) {
    return "";
  }
  const name = getAssetShortName(asset as AssetResponse) || asset;
  const suffix = findTradingTypeByInstrument(
    instrumentType as InstrumentTypeResponse | undefined
  )?.quoteLabelSuffix;
  return suffix ? `${name}${suffix}` : name;
};
